import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cn from 'classnames';
import ItemTitle from 'swag-client-common/components/partials/item-title';
import { Price } from 'swag-client-common/utils/price';
import anim from '../../../fade-in-out.scss';
import css from '../content.scss';
const AddonInfoBlock = ({
  productName,
  quantityPerBox,
  itemPriceValue,
  onChangeHowManyAddonInEachBox,
  handleSelectItem,
  totalCount
}) => {
  const transformedItemPriceValue = Price.formatNumber(itemPriceValue);
  return /*#__PURE__*/React.createElement("div", {
    className: css.cardInfoWrapper
  }, /*#__PURE__*/React.createElement("div", {
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement(ItemTitle, {
    productName: productName,
    productNameClass: css.productNameClass
  }), /*#__PURE__*/React.createElement("div", {
    className: css.inEachBoxLine
  }, /*#__PURE__*/React.createElement("span", {
    className: css.inEachBoxText
  }, "Quantity in each box?"), /*#__PURE__*/React.createElement("input", {
    "data-input": "QuantityPerBox",
    type: "text",
    value: quantityPerBox,
    onFocus: handleSelectItem,
    onChange: e => {
      const val = Number(e.target.value);
      if (Number.isNaN(val) || val < 0 || val > 99) {
        return;
      }
      onChangeHowManyAddonInEachBox(val);
    },
    className: cn(css.pink, css.howManyInEachBoxCol)
  }), /*#__PURE__*/React.createElement("span", {
    className: css.inEachBoxTotal
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: totalCount || 0,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    "data-text": "ProductTotal"
  }, "(Total: ", totalCount || 0, ")")))))), /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: transformedItemPriceValue || 0,
    timeout: 250
  }, /*#__PURE__*/React.createElement("div", {
    className: css.price
  }, /*#__PURE__*/React.createElement("span", {
    className: css.priceText
  }, "Item price:"), /*#__PURE__*/React.createElement("span", {
    className: css.priceValue,
    "data-text": "ItemPrice"
  }, "\xA0", transformedItemPriceValue || 0)))));
};
export default AddonInfoBlock;